export const balanceToString = (balance) => balance.toLocaleString(undefined, { maximumFractionDigits: 7 });

export const formatBalance = (balance, isNft) =>
  balanceToString(Math.round(Number(balance)*(isNft ? 10000000 : 1)*10000000)/10000000);


// WEBPACK FOOTER //
// ./src/components/balances.js